import { Link, useLocation } from 'react-router-dom';
import { Home, Ticket, User, QrCode } from 'lucide-react';

const navItems = [
  { to: '/events', label: 'Events', icon: Home },
  { to: '/my-tickets', label: 'Tickets', icon: Ticket },
  { to: '/ticket/scan', label: 'Scan', icon: QrCode },
  { to: '/profile', label: 'Profile', icon: User },
];

export function BottomNav({ items = navItems }) {
  const location = useLocation();
  
  return (
    <nav className="bottom-nav">
      <div className="flex justify-around items-center">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.to || 
                          location.pathname.startsWith(item.to + '/');
          
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon className="w-6 h-6" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

// Customer-specific bottom nav
export function CustomerBottomNav() {
  const items = [
    { to: '/events', label: 'Events', icon: Home },
    { to: '/my-tickets', label: 'My Tickets', icon: Ticket },
  ];
  
  return <BottomNav items={items} />;
}

// Staff-specific bottom nav
export function StaffBottomNav() {
  const items = [
    { to: '/staff/scanner', label: 'Scanner', icon: QrCode },
  ];
  
  return <BottomNav items={items} />;
}

export default BottomNav;
